import 'jquery';
import 'jquery-ui-dist/jquery-ui.min.js'
import 'jquery.cookie'
import 'slick-carousel';
import '@fancyapps/fancybox';
import gsap from 'gsap/dist/gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import Power1 from 'gsap';
import Headroom from 'headroom.js';


gsap.registerPlugin(ScrollTrigger);

window.appJs = {};

(function (appJsApp) {

    /* ==========================================================================
      jQuery UI - Accordion
       ========================================================================== */

    appJsApp.InitializeAccordion = function () {
        if (document.querySelector(".accordion")) {
            $(".accordion").accordion({
                collapsible: true,
                heightStyle: "content",
                active: false
            });
        }
    }

    $(document).ready(function () {

        appJsApp.InitializeAccordion();

        /* ==========================================================================
           Fade in elements with intersection observer
           ========================================================================== */

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting === true) {
                        entry.target.classList.add("fade-in--is-visible");
                    } else {
                        //entry.target.classList.remove("fade-in--is-visible");
                    }
                });
            }, { threshold: 0.8 });
            var items = document.querySelectorAll(".fade-in");
            items.forEach(function (item, index) {
                observer.observe(item, index);
            });
        } else {
            document.querySelector("body").classList.add("no-intersection-observer")
        }

        /* ==========================================================================
           Ingredients animation - intersection observer
           ========================================================================== */

        if ('IntersectionObserver' in window) {
            let options = {
                rootMargin: '1000px 0px -300px 0px',
                threshold: 1
            }
            var ingredientsObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting === true) {
                        entry.target.classList.add("is-visible");
                    } else {
                        entry.target.classList.remove("is-visible");
                    }
                });
            }, options);
            var ingredientItems = document.querySelectorAll(".ingredients-animation__item");
            ingredientItems.forEach(function (item, index) {
                ingredientsObserver.observe(item, index);
            });
        } else {
            document.querySelector("body").classList.add("no-intersection-observer")
        }

        /* ==========================================================================
           Product detail sticky panel
           ========================================================================== */

        if (document.querySelector(".product-sticky-panel")) {
            if ('IntersectionObserver' in window) {
                var stickyEl = document.querySelector(".product-sticky-panel");
                var productPanelEl = document.querySelector(".product-page-banner");

                var handler = function handler(entries) {
                    if (!entries[0].isIntersecting) {
                        stickyEl.classList.add("product-sticky-panel--reveal");
                    } else {
                        stickyEl.classList.remove("product-sticky-panel--reveal");
                    }
                };

                var observer = new window.IntersectionObserver(handler);
                observer.observe(productPanelEl);
            }
        }

        /* ==========================================================================
           Change header on scroll
           ========================================================================== */

        if (document.querySelector(".header")) {
            if ('IntersectionObserver' in window) {
                var headerEl = document.querySelector(".header");
                var sentinalEl = document.querySelector(".header-sentinal");

                var handler = function handler(entries) {
                    if (!entries[0].isIntersecting) {
                        headerEl.classList.add("header--scrolled");
                        headerEl.classList.remove("header--initial");
                    } else {
                        headerEl.classList.remove("header--scrolled");
                        headerEl.classList.add("header--initial");
                    }
                };

                var observer = new window.IntersectionObserver(handler);
                observer.observe(sentinalEl);
            }

            var headroomOptions = {
                offset: {
                    up: 0,
                    down: 110
                },
                onUnpin : function() {
                	$(".sub-nav").hide();
                	$(".main-nav__link").removeClass("main-nav__link--sub-nav-active");
                }
            }
            const headroomHeader = document.querySelector(".header");
            const headroom = new Headroom(headroomHeader, headroomOptions);
            headroom.init();
        }

        /* ==========================================================================
           Mobile Menu Button
           ========================================================================== */

        $(".js-trigger-mobile-nav").click(function () {
            $(".main-nav").fadeToggle(250);
            $(this).toggleClass("is-active");
            $(".header").toggleClass("header--mobile-nav-active");
            $(".sub-nav").fadeOut(250);
            $("body").toggleClass("lock-scroll");
        });

        /* ==========================================================================
           Sub nav 
           ========================================================================== */

        $(".js-toggle-subnav").click(function (e) {
            e.preventDefault();
            var thisNav = $(this).parent().find(".sub-nav");
            $(".main-nav__link").not(this).removeClass("main-nav__link--sub-nav-active");
            $(".sub-nav").not(thisNav).fadeOut(250);
            $(this).toggleClass("main-nav__link--sub-nav-active");
            $(this).parent().find(".sub-nav").fadeToggle(250);
        });

        $(".js-close-subnav").click(function (e) {
            e.preventDefault();
            $(".sub-nav").fadeOut(250);
            $(".main-nav__link").removeClass("main-nav__link--sub-nav-active");
        });

        /* ==========================================================================
           Cookie Banner
           ========================================================================== */

        $(".js-close-cookie-banner").click(function () {
            $(".cookie-banner").fadeOut(250);
        });

        /* ==========================================================================
           Pet toggle 
           ========================================================================== */

        $(".js-pet-toggle").click(function (e) {
            var dataId = $(this).attr("data-id");
            $(".js-pet-toggle").not('.button[data-id="' + dataId + '"]').removeClass("is-active");
            $(".pet-toggle__buttons-image").removeClass("is-active");
            $('.button[data-id="' + dataId + '"]').addClass("is-active");
            $(".pet-toggle-results").not( "#" + dataId).fadeOut(100, function(){
                $( "#" + dataId).fadeIn(100);
            });
        });

        /* ==========================================================================
           Featured product overlay
           ========================================================================== */

        $(".js-toggle-featured-product-overlay").click(function (e) {
            e.preventDefault();
            $(this).parents(".featured-product").find(".featured-product__overlay").fadeToggle(250);
            $(this).parents(".featured-product").toggleClass("featured-product--is-active");
        });

        /* ==========================================================================
           Product/Article Filter toggle 
           ========================================================================== */

        $(document).on("click", ".js-filter-toggle", function (e) {
            $(this).parent().find(".filters-popup").fadeToggle(250);
        });

        $(document).on("click", ".js-close-toggle", function (e) {
            $(".filters-popup").fadeOut(250);
        });

        /* ==========================================================================
           Search Filter toggle 
           ========================================================================== */

        $(".js-toggle-search-filters").click(function (e) {
            $(this).toggleClass("is-active");
            $(this).parent().find(".search-results-filters").fadeToggle(250);
        });

        /* ==========================================================================
           Stockist panel toggle (mobile only)
           ========================================================================== */

        $(".js-toggle-stockists-panel").click(function (e) {
            $(this).toggleClass("is-active");
            $(this).parents(".contact-panel").find(".contact-panel__container").slideToggle(250);
            $(this).parents(".contact-panel").toggleClass("is-active");
        });

        /* ==========================================================================
           Slick Sliders
           ========================================================================== */

        $('.js-articles-slider').slick({
            fade: false,
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: "unslick"
                }
            ]
        });

        $('.js-featured-products-slider').slick({
            fade: false,
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1441,
                    settings: "unslick"
                }
            ]
        });

        $('.js-testimonial-gallery').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 740,
                    settings: "unslick"
                }
            ]
        });

        /* ==========================================================================
          Product Gallery Fancybox popup 
           ========================================================================== */

        $('.js-product-gallery-popup').fancybox({
            "touch": false,
            afterLoad: function (instance, current) {
                $('.js-product-gallery-thumbs').slick('setPosition');
                $('.js-product-gallery-main').slick('setPosition');
                if ($('.model-viewer').length) {
                    document.querySelector('.model-viewer').dismissPoster();
                }
            }
        });

        /* ==========================================================================
          jQuery UI - Tabs
           ========================================================================== */

        if (document.querySelector(".tabs")) {
            $(".tabs").tabs();
        }

        /* ==========================================================================
          Greensock - Parallax 
           ========================================================================== */

        if (window.matchMedia("(min-width: 	1024px)").matches) {

            gsap.utils.toArray(".parallax-background").forEach(layer => {
                gsap.to(layer, {
                    yPercent: -5,
                    ease: "none",
                    scrollTrigger: {
                        trigger: ".parallax-banner",
                        start: "top top",
                        end: "bottom top",
                        scrub: 0.6
                    },
                });
            });

            gsap.utils.toArray(".parallax-content").forEach(layer => {
                gsap.to(layer, {
                    yPercent: 10,
                    ease: "none",
                    scrollTrigger: {
                        trigger: ".image-text-group",
                        scrub: 0.6
                    },
                });
            });

            gsap.utils.toArray(".parallax-image").forEach(layer => {
                gsap.to(layer, {
                    yPercent: -5,
                    ease: "none",
                    scrollTrigger: {
                        trigger: ".image-text-group",
                        scrub: 0.6
                    },
                });
            });
        }

        /* ==========================================================================
          Greensock - Hero main banner animation
           ========================================================================== */

        // Animate the main hero banner clip-path with scrollbar scrub
        if (document.querySelector(".hero-main-banner--animate")) {
            let mainBannerTimelineClip = gsap.timeline({
                scrollTrigger: {
                    trigger: ".hero-main-banner--animate",
                    start: "top 50%",
                    end: "bottom -20%",
                    scrub: true,
                }
            })
                .to('.hero-main-banner__clip', { clipPath: "inset(0vw)" })
                .to('.hero-main-banner__clip', { clipPath: "inset(5vw)" })

            let productBannerTimelineContent = gsap.timeline({
                scrollTrigger: {
                    trigger: ".hero-main-banner--animate",
                    start: "top 20%",
                    end: "bottom top",
                    //toggleActions: "play reverse play reverse",
                    toggleClass: "animation-active"
                }
            })
                .to(".hero-main-banner--animate .hero-main-banner__content-frame", { ease: Power1.easeOut, autoAlpha: 1 }, 0)
                .to(".hero-main-banner--animate .hero-main-banner__title", { ease: Power1.easeOut, translateY: 0, autoAlpha: 1 }, "<0.25")
                .to(".hero-main-banner--animate .hero-main-banner__paragraph", { ease: Power1.easeOut, translateY: 0, autoAlpha: 1 }, "<0.25")
                .to(".hero-main-banner--animate .hero-main-banner__buttons", { ease: Power1.easeOut, translateY: 0, autoAlpha: 1 }, "<0.25");
        }

        /* ==========================================================================
          Greensock - Featured products banner animation
           ========================================================================== */

        if (document.querySelector(".featured-products--animate")) {
            if (window.matchMedia("(min-width: 1440px)").matches) {
                //Add padding to centre the first slide
                let featurePanelWidth = $(".featured-products--animate .featured-products__panel").outerWidth();
                let windowWidth = $(window).width();
                let featurePaddingLeft = (windowWidth - featurePanelWidth) / 2;
                $(".featured-products--animate .featured-products__panel").first().css("padding-left", featurePaddingLeft)


                const sections = gsap.utils.toArray(".featured-products--animate .featured-products .featured-products__panel");
                let maxWidth = 0;

                const getMaxWidth = () => {
                  maxWidth = 0;
                  sections.forEach((section) => {
                    maxWidth += section.offsetWidth;
                  });
                };
                getMaxWidth();
                ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

                gsap.to(sections, {
                  x: () => `-${maxWidth - window.innerWidth}`,
                  ease: "none",
                  scrollTrigger: {
                    trigger: ".featured-products--animate .featured-products",
                    pin: true,
                    scrub: 0.5,
                    end: () => `+=${maxWidth}`,
                    invalidateOnRefresh: true
                  }
                });

                sections.forEach((sct, i) => {
                  ScrollTrigger.create({
                    trigger: sct,
                    start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (maxWidth / (maxWidth - window.innerWidth)),
                    end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
                    toggleClass: {targets: sct, className: "active"}
                  });
                });
            }
        }

        /* ==========================================================================
          Greensock - Hero product banner animation
           ========================================================================== */

        //timeline.to(target, duration, vars, position);

        // Animate the product banner clip-path with scrollbar scrub
        if (document.querySelector(".hero-product-banner--animate")) {
            if (window.matchMedia("(min-width: 740px)").matches) {
                let productBannerTimelineClip = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".hero-product-banner--animate .hero-product-banner",
                        start: "top 100%",
                        end: "bottom -100%",
                        scrub: true,
                    }
                })
                .to('.hero-product-banner__clip', { clipPath: "inset(5vw)" })
                .to('.hero-product-banner__clip', { clipPath: "inset(0vw)" })
                .to('.hero-product-banner__clip', { duration: 1, clipPath: "inset(0vw)" })
                .to('.hero-product-banner__clip', { clipPath: "inset(0vw)" })
                .to('.hero-product-banner__clip', { clipPath: "inset(5vw)" })

                let productBannerTimelineContent = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".hero-product-banner--animate .hero-product-banner",
                        pin: true,
                        start: "top top",
                        end: "+=100%",
                        //toggleActions: "play reverse play reverse",
                        toggleClass: "animation-active"
                    }
                })
                .from(".hero-product-banner--animate .hero-product-banner__content-frame", { autoAlpha: 0 }, 0)
                .from(".hero-product-banner--animate .hero-product-banner__pack", { ease: Power1.easeOut, translateY: 20, autoAlpha: 0 }, 0)
                .from(".hero-product-banner--animate .hero-product-banner__title", { ease: Power1.easeOut, translateY: 20, autoAlpha: 0 }, "<0.25")
                .from(".hero-product-banner--animate .hero-product-banner__paragraph", { ease: Power1.easeOut, translateY: 20, autoAlpha: 0 }, "<0.25")
                .from(".hero-product-banner--animate .hero-product-banner__content-buttons", { ease: Power1.easeOut, translateY: 20, autoAlpha: 0 }, "<0.25");
            }
        }


        /* ==========================================================================
          Product Buy Now
           ========================================================================== */

        $('.js-product-buy-now').fancybox({
            iframe: {
                css: {
                    'width': 800,
                    'height': 600,
                    'max-width': '95%',
                    'max-height': '95%'
                }
            }
        });

        /* ==========================================================================
          Blog Article
           ========================================================================== */
        $("#bioButton").click(function () {
            if ($('#biographyContainer').css('display') == 'none') {
                $('#biographyContainer').css('display', 'block');
                $('#bioButton').text('Hide bio');

            } else {
                $('#biographyContainer').css('display', 'none');
                $('#bioButton').text('Read bio');
            }
        });

        /* ==========================================================================
         Cookie Banner
          ========================================================================== */

        $(".js-close-cookie-banner").click(function () {
            var cookieName = $(this).data('cookie');
            $(".cookie-banner").hide();
            $.cookie(cookieName, true, { expires: 365, path: '/' });
        })

        /* ==========================================================================
        Make (R) Registered (C) Copyright (TM) Trade marks ® © ™ superscript
        ========================================================================== */
        const marksRegexes = [/[\xAE]/,/[\u2122]/,/[\xA9]/];
        const marksSups = ["<sup>$&</sup>","<sup>&#8482</sup>","<sup>&#169</sup>"];
        $('body :not(script,sup)').contents().filter(function () {            
            return this.nodeType === 3 && (marksRegexes.some(x => x.test(this.nodeValue)));
        }).replaceWith(function () {
            for (let i = 0; i < marksRegexes.length; i++) {
                this.nodeValue = this.nodeValue.replace(marksRegexes[i], marksSups[i]);
            }
            return this.nodeValue;
        });

    }); // document ready
})(window.appJs);
